import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";

const initialState: State = {
  isPending: false,
  isSuccessful: false,
  isFailure: false,
};

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.addPlanzoneMaterialResourceRequested]: setRequestStateToPending,
    [events.addPlanzoneMaterialResourceSucceeded]: setRequestStateToSuccess,
    [events.addPlanzoneMaterialResourceFailed]: setRequestStateToFailure,
  }),
  [events.changePlanzoneSucceeded],
);

function createSelector(getState: () => State): Selector {
  return {
    isAddPlanzoneMaterialResourceRequestFailure() {
      return getState().isFailure;
    },
    isAddPlanzoneMaterialResourceRequestPending() {
      return getState().isPending;
    },
    isAddPlanzoneMaterialResourceRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
